import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const MicrophoneIcon = createIcon({
  displayName: 'MicrophoneIcon',
  path: [
    <g clipPath='url(#a)'>
      <path
        fill='currentColor'
        d='M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3Zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16c-2.47 0-4.52-1.8-4.93-4.15a.998.998 0 0 0-.98-.85c-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08a6.993 6.993 0 0 0 5.91-5.78c.1-.6-.39-1.14-1-1.14Z'
      />
    </g>,
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  ],
  defaultProps: defaultProps
})
